<template>
  <div class="footer-index wrapper">
    <div class="footer-box">
      <div class="footer-info">
        <div class="info-text">
          <p class="text-self">Contact Ss-Group</p>
          <p class="text-self">WhatsApp : +213 797 87 87 41</p>
          <p class="text-self">WeChat: +86 15295780013</p>
        </div>
        <div class="footer-img">
          <p class="img-text">Empowering Agerian Students,Connecting Dreams to China</p>
        </div>
      </div>
      <p class="footer-text">© 2024 Ss-group. All rights reserved.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterIndex',
  props: {},
  data () {
    return {
    }
  },
  components: {},
  computed: {},
  created () {},
  watch: {},
  methods: {}
}
</script>

<style scoped>
.footer-index{position: absolute;bottom:55px;}
.footer-box{background-color:#e7e6e6;padding:30px 28px 15px;box-sizing:border-box;position:relative;bottom:0;}
.footer-index .footer-title{display: block;position: absolute;top:-12px;left:50%;transform:translate(-50%,0);width:172px;}
.footer-index .footer-info{overflow:hidden;padding-bottom:10px;border-bottom:1px solid #333;}
.footer-index .footer-info .info-text{float:left;width:50%;color:#333;font-size:12px;}
.footer-index .footer-info .info-text .text-self{margin-bottom:10px;}
.footer-index .footer-text{font-size:12px;margin-top:20px;}
.footer-index .footer-info .footer-img{float:left;width:50%;}
.footer-index .footer-info .footer-img .img-self{display: block;width:80px;height:80px;margin:0 auto 10px;}
.footer-index .footer-info .footer-img .img-text{font-size:12px;color:#333;text-align: center;}
</style>
